import { CommandAction } from "./types";

// Deep actions surfaced in the header search under "การดำเนินการ".
//
// Pages are derived automatically from the menu (masterData.actionList) and do
// NOT belong here — this list is only for actions that have no menu entry of
// their own: a thing the user wants to DO (add/create/assign/approve/adjust).
//
// Most entries are PURE-NAV: navigate_to points at the page whose visible,
// permission-gated button performs the action, so they work with zero page
// wiring. An entry with `action_param` auto-opens a modal on the destination
// page — that destination MUST read ?action=<param> via useSearchParams and
// open the matching modal, then strip the param. Only add action_param when
// the modal lives on the SAME page navigate_to lands on (otherwise pure-nav).
export const COMMAND_ACTIONS: CommandAction[] = [
	// ── Product ──
	{
		id: "add_product",
		label: "เพิ่มสินค้า",
		keywords: ["เพิ่มสินค้า", "สร้างสินค้า", "สินค้าใหม่", "add product", "create product", "new product"],
		breadcrumb: "สินค้า › รายการสินค้า",
		icon: "bi bi-plus-circle",
		main_module_code: "PRODUCT",
		module_code: "PRODUCTS",
		required_verb: "create",
		navigate_to: "/products/list",
	},
	{
		id: "edit_product",
		label: "แก้ไขสินค้า",
		keywords: ["แก้ไขสินค้า", "อัปเดตสินค้า", "แก้ไขข้อมูลสินค้า", "edit product", "update product"],
		breadcrumb: "สินค้า › รายการสินค้า",
		icon: "bi bi-pencil",
		main_module_code: "PRODUCT",
		module_code: "PRODUCTS",
		required_verb: "edit",
		navigate_to: "/products/list",
	},
	{
		id: "add_product_category",
		label: "เพิ่มประเภทสินค้า",
		keywords: ["เพิ่มประเภทสินค้า", "สร้างประเภทสินค้า", "ประเภทสินค้าใหม่", "หมวดสินค้า", "add category", "create category", "new category"],
		breadcrumb: "สินค้า › ประเภทสินค้า",
		icon: "bi bi-folder-plus",
		main_module_code: "PRODUCT",
		module_code: "PRODUCT_CAT",
		required_verb: "create",
		navigate_to: "/products/categories",
	},
	{
		id: "add_tag",
		label: "เพิ่มแท็กสินค้า",
		keywords: ["เพิ่มแท็ก", "สร้างแท็ก", "แท็กใหม่", "add tag", "create tag", "new tag"],
		breadcrumb: "สินค้า › แท็กสินค้า",
		icon: "bi bi-tag",
		main_module_code: "PRODUCT",
		module_code: "TAG",
		required_verb: "create",
		navigate_to: "/products/tags",
	},

	// ── Member ──
	{
		id: "add_member",
		label: "เพิ่มสมาชิก",
		keywords: ["เพิ่มสมาชิก", "สร้างสมาชิก", "ลงทะเบียนสมาชิก", "สมาชิกใหม่", "add member", "create member", "register member", "new member"],
		breadcrumb: "จัดการสมาชิก › รายการสมาชิก",
		icon: "bi bi-person-plus",
		main_module_code: "MEMBER_MANAGEMENT",
		module_code: "MEMBER_LIST",
		required_verb: "create",
		navigate_to: "/member/list",
	},
	{
		id: "edit_member",
		label: "แก้ไขข้อมูลสมาชิก",
		keywords: ["แก้ไขสมาชิก", "อัปเดตสมาชิก", "แก้ไขข้อมูลสมาชิก", "เปลี่ยนข้อมูลสมาชิก", "edit member", "update member"],
		breadcrumb: "จัดการสมาชิก › รายการสมาชิก",
		icon: "bi bi-person-gear",
		main_module_code: "MEMBER_MANAGEMENT",
		module_code: "MEMBER_LIST",
		required_verb: "edit",
		navigate_to: "/member/list",
	},
	{
		id: "add_member_point",
		label: "เพิ่มรายการคะแนนสมาชิก",
		keywords: ["เพิ่มคะแนน", "เพิ่มรายการคะแนน", "ปรับคะแนน", "คะแนนสมาชิก", "add point", "adjust point", "earn point", "redeem point", "member point"],
		breadcrumb: "จัดการสมาชิก › คะแนนสมาชิก",
		icon: "bi bi-star-fill",
		main_module_code: "MEMBER_MANAGEMENT",
		module_code: "MEMBER_POINT",
		required_verb: "create",
		navigate_to: "/member/point",
	},
	{
		id: "add_member_tier",
		label: "เพิ่มระดับสมาชิก",
		keywords: ["เพิ่มระดับสมาชิก", "สร้างระดับสมาชิก", "ระดับใหม่", "add tier", "create tier", "member tier"],
		breadcrumb: "จัดการสมาชิก › ระดับสมาชิก",
		icon: "bi bi-award",
		main_module_code: "MEMBER_MANAGEMENT",
		module_code: "MEMBER_TIER",
		required_verb: "create",
		navigate_to: "/member/tier",
	},

	// ── Employee ──
	{
		id: "add_employee",
		label: "เพิ่มพนักงานใหม่",
		keywords: ["เพิ่มพนักงาน", "สร้างพนักงาน", "พนักงานใหม่", "add employee", "create employee", "new employee"],
		breadcrumb: "พนักงาน › รายการพนักงาน",
		icon: "bi bi-person-plus",
		main_module_code: "EMPLOYEE",
		module_code: "EMPLOYEES",
		required_verb: "create",
		navigate_to: "/employee/list",
	},
	{
		id: "add_employee_branch",
		label: "เพิ่มสาขาให้พนักงาน",
		keywords: ["เพิ่มสาขาพนักงาน", "กำหนดสาขา", "ผูกสาขา", "เพิ่มสาขา", "assign branch employee", "add branch to employee"],
		breadcrumb: "พนักงาน › รายการพนักงาน",
		icon: "bi bi-building-add",
		main_module_code: "EMPLOYEE",
		module_code: "EMPLOYEES",
		required_verb: "edit",
		navigate_to: "/employee/list",
	},
	{
		id: "link_line_account_employee",
		label: "ผูกบัญชี LINE พนักงาน",
		keywords: ["ผูก LINE", "ลิงก์ LINE", "เชื่อม LINE", "สร้างรหัส LINE", "LINE OA", "link LINE account", "generate line code"],
		breadcrumb: "พนักงาน › รายการพนักงาน",
		icon: "bi bi-chat-dots",
		main_module_code: "EMPLOYEE",
		module_code: "EMPLOYEES",
		required_verb: "edit",
		navigate_to: "/employee/list",
	},
	{
		id: "add_position",
		label: "เพิ่มตำแหน่งพนักงาน",
		keywords: ["เพิ่มตำแหน่ง", "สร้างตำแหน่ง", "ตำแหน่งใหม่", "add position", "create position", "new position"],
		breadcrumb: "พนักงาน › ตำแหน่งพนักงาน",
		icon: "bi bi-briefcase",
		main_module_code: "EMPLOYEE",
		module_code: "EMPLOYEE_POS",
		required_verb: "create",
		navigate_to: "/employee/position",
	},
	{
		id: "add_leave_request",
		label: "เพิ่มคำขอลา",
		keywords: ["ขอลา", "สร้างคำขอลา", "บันทึกการลา", "ลาพนักงาน", "add leave request", "create leave request", "leave request"],
		breadcrumb: "พนักงาน › จัดการการลา",
		icon: "bi bi-calendar-check",
		main_module_code: "EMPLOYEE",
		module_code: "LEAVE_MANAGEMENT",
		required_verb: "create",
		navigate_to: "/employee/leave-management",
	},
	{
		id: "approve_leave_request",
		label: "อนุมัติ/ปฏิเสธคำขอลา",
		keywords: ["อนุมัติการลา", "ปฏิเสธการลา", "จัดการคำขอลา", "อัปเดตสถานะการลา", "approve leave", "reject leave"],
		breadcrumb: "พนักงาน › จัดการการลา",
		icon: "bi bi-check2-circle",
		main_module_code: "EMPLOYEE",
		module_code: "LEAVE_MANAGEMENT",
		required_verb: "edit",
		navigate_to: "/employee/leave-management",
	},
	{
		id: "add_leave_type",
		label: "เพิ่มประเภทการลา",
		keywords: ["เพิ่มประเภทลา", "สร้าง leave type", "ประเภทการลาใหม่", "ตั้งค่าการลา", "add leave type", "create leave type"],
		breadcrumb: "พนักงาน › ตั้งค่าการลา",
		icon: "bi bi-calendar-plus",
		main_module_code: "EMPLOYEE",
		module_code: "LEAVE_SETTINGS",
		required_verb: "create",
		navigate_to: "/employee/leave",
	},

	// ── Inventory ──
	{
		id: "create_master_order_wms_inbound",
		label: "สร้าง Master Order นำเข้าคลัง",
		keywords: ["สร้าง master order", "นำเข้าคลัง", "รับสินค้าเข้าคลัง", "ใบนำเข้า", "สั่งซื้อ", "wms inbound", "create master order", "inbound"],
		breadcrumb: "คลังสินค้า › Master Order",
		icon: "bi bi-box-arrow-in-down",
		main_module_code: "INVENTORY",
		module_code: "MASTER_ORDER",
		required_verb: "create",
		navigate_to: "/inventory/master_orders/create-wms-inbound",
	},
	{
		id: "create_master_order_wms_outbound",
		label: "สร้าง Master Order กระจายสาขา",
		keywords: ["สร้าง master order", "กระจายสาขา", "กระจายสินค้า", "ส่งสินค้าออก", "ใบกระจาย", "wms outbound", "create master order", "outbound"],
		breadcrumb: "คลังสินค้า › Master Order",
		icon: "bi bi-box-arrow-up",
		main_module_code: "INVENTORY",
		module_code: "MASTER_ORDER",
		required_verb: "create",
		navigate_to: "/inventory/master_orders",
	},
	{
		id: "create_transfer_order",
		label: "สร้าง Transfer Order โอนสินค้า",
		keywords: ["สร้าง transfer order", "transfer สินค้า", "โอนสินค้าระหว่างสาขา", "โอนสต็อก", "ย้ายสินค้า", "create transfer", "transfer order"],
		breadcrumb: "คลังสินค้า › Transfer สินค้า",
		icon: "bi bi-arrow-left-right",
		main_module_code: "INVENTORY",
		module_code: "TRANSFER_ORDER",
		required_verb: "create",
		navigate_to: "/inventory/transfer_orders",
	},
	{
		id: "manual_stock_adjustment",
		label: "ปรับสต็อกแบบ Manual",
		keywords: ["ปรับสต็อก", "manual adjustment", "stock adjustment", "แก้ไขสต็อก", "ปรับจำนวนสินค้า", "ปรับสต็อกมือ", "adjust stock"],
		breadcrumb: "คลังสินค้า › ปรับสต็อก",
		icon: "bi bi-pencil-square",
		main_module_code: "INVENTORY",
		module_code: "STOCK_ADJUST",
		required_verb: "edit",
		navigate_to: "/inventory/stock_adjustments",
		action_param: "manual_adjust",
	},
	{
		id: "import_initial_stock",
		label: "นำเข้าสต็อกเริ่มต้น (Excel)",
		keywords: ["นำเข้าสต็อก", "import stock", "สต็อกเริ่มต้น", "initial stock", "ตั้งต้นสต็อก", "นำเข้า excel"],
		breadcrumb: "คลังสินค้า › ปรับสต็อก",
		icon: "bi bi-file-earmark-arrow-up",
		main_module_code: "INVENTORY",
		module_code: "STOCK_ADJUST",
		required_verb: "edit",
		navigate_to: "/inventory/stock_adjustments",
	},
	{
		id: "create_write_off",
		label: "สร้าง Write Off ตัดสต็อก",
		keywords: ["สร้าง write off", "write off", "ตัดสต็อก", "สินค้าเสียหาย", "สินค้าหมดอายุ", "สินค้าสูญหาย", "ตัดจำหน่าย", "ชำรุด", "create write off"],
		breadcrumb: "คลังสินค้า › Write Off สต็อก",
		icon: "bi bi-trash3",
		main_module_code: "INVENTORY",
		module_code: "WRITE_OFF",
		required_verb: "create",
		navigate_to: "/inventory/write_offs",
	},
	{
		id: "create_cycle_count",
		label: "เพิ่มใบนับสต็อก",
		keywords: ["สร้างใบนับสต็อก", "cycle count", "นับสต็อก", "ใบนับ", "นับสินค้า", "ตรวจนับสต็อก", "create cycle count", "เพิ่มใบนับ"],
		breadcrumb: "คลังสินค้า › ใบนับสต็อก",
		icon: "bi bi-clipboard-check",
		main_module_code: "INVENTORY",
		module_code: "CYCLE_COUNT",
		required_verb: "create",
		navigate_to: "/inventory/cycle_counts",
	},
	{
		id: "create_wms_return",
		label: "สร้างเอกสารส่งคืนสินค้าไป WMS",
		keywords: ["ส่งคืน wms", "wms return", "คืนสินค้า", "ส่งสินค้าคืนคลัง", "สร้างเอกสารส่งคืน", "create wms return"],
		breadcrumb: "คลังสินค้า › ส่งคืนสินค้าไป WMS",
		icon: "bi bi-arrow-return-left",
		main_module_code: "INVENTORY",
		module_code: "WMS_RETURN",
		required_verb: "create",
		navigate_to: "/inventory/wms_returns",
		action_param: "add",
	},

	// ── Sale ──
	{
		id: "create_promotion",
		label: "สร้างโปรโมชัน",
		keywords: ["สร้างโปรโมชัน", "เพิ่มโปรโมชัน", "โปรโมชันใหม่", "ส่วนลด", "บันเดิล", "create promotion", "add promotion", "discount", "bundle"],
		breadcrumb: "การขาย › โปรโมชัน",
		icon: "bi bi-tags",
		main_module_code: "SALE",
		module_code: "PROMOTION_LIST",
		required_verb: "create",
		navigate_to: "/sale/promotion",
	},
	{
		id: "edit_promotion",
		label: "แก้ไขโปรโมชัน",
		keywords: ["แก้ไขโปรโมชัน", "อัปเดตโปรโมชัน", "เปิดปิดโปรโมชัน", "edit promotion", "update promotion", "toggle promotion"],
		breadcrumb: "การขาย › โปรโมชัน",
		icon: "bi bi-pencil-square",
		main_module_code: "SALE",
		module_code: "PROMOTION_LIST",
		required_verb: "edit",
		navigate_to: "/sale/promotion",
	},
	{
		id: "approve_sale_return",
		label: "อนุมัติใบคืนสินค้า",
		keywords: ["อนุมัติคืนสินค้า", "อนุมัติใบคืน", "รออนุมัติ", "คืนสินค้า", "approve sale return", "approve return", "pending return"],
		breadcrumb: "การขาย › คืนสินค้า",
		icon: "bi bi-check-circle",
		main_module_code: "SALE",
		module_code: "SALE_RETURN",
		required_verb: "edit",
		navigate_to: "/sale/returns",
	},
	{
		id: "reject_sale_return",
		label: "ปฏิเสธใบคืนสินค้า",
		keywords: ["ปฏิเสธคืนสินค้า", "ปฏิเสธใบคืน", "ไม่อนุมัติคืนสินค้า", "reject sale return", "reject return", "decline return"],
		breadcrumb: "การขาย › คืนสินค้า",
		icon: "bi bi-x-circle",
		main_module_code: "SALE",
		module_code: "SALE_RETURN",
		required_verb: "edit",
		navigate_to: "/sale/returns",
	},
	{
		id: "configure_return_setting",
		label: "ตั้งค่าระยะเวลาคืนสินค้า",
		keywords: ["ตั้งค่าคืนสินค้า", "ระยะเวลาคืนสินค้า", "จำนวนวันคืนสินค้า", "configure return", "return window", "return setting", "return days"],
		breadcrumb: "การขาย › ตั้งค่าคืนสินค้า",
		icon: "bi bi-sliders",
		main_module_code: "SALE",
		module_code: "SALE_RETURN",
		required_verb: "edit",
		navigate_to: "/sale/returns/setting",
	},
	{
		id: "create_content",
		label: "เพิ่มเนื้อหาสื่อจอลูกค้า",
		keywords: ["เพิ่มเนื้อหา", "สร้างเนื้อหา", "เนื้อหาใหม่", "สื่อ", "สไลด์", "จอลูกค้า", "add content", "create content", "media", "customer display"],
		breadcrumb: "การขาย › จัดการเนื้อหา",
		icon: "bi bi-play-btn",
		main_module_code: "SALE",
		module_code: "CONTENT_MANAGEMENT",
		required_verb: "create",
		navigate_to: "/sale/content",
	},

	// ── Branch / Cash ──
	{
		id: "add_branch",
		label: "เพิ่มสาขา",
		keywords: ["เพิ่มสาขา", "สร้างสาขา", "สาขาใหม่", "add branch", "create branch", "new branch"],
		breadcrumb: "สาขา › จัดการสาขา",
		icon: "bi bi-building-add",
		main_module_code: "BRANCH",
		module_code: "BRANCH_MANAGE",
		required_verb: "create",
		navigate_to: "/branch/management",
	},
	{
		id: "deposit_safe",
		label: "ฝากเงินเข้าตู้นิรภัย",
		keywords: ["ฝากเซฟ", "ฝากตู้นิรภัย", "ฝากเงิน", "เงินสด", "safe deposit", "deposit safe"],
		breadcrumb: "สาขา › จัดการเงินสด",
		icon: "bi bi-safe",
		main_module_code: "BRANCH",
		module_code: "CASH_MANAGE",
		required_verb: "create",
		navigate_to: "/branch/cash_management",
	},
	{
		id: "withdraw_safe",
		label: "ถอนเงินจากตู้นิรภัย",
		keywords: ["ถอนเซฟ", "ถอนตู้นิรภัย", "ถอนเงินสด", "safe withdrawal", "withdraw safe"],
		breadcrumb: "สาขา › จัดการเงินสด",
		icon: "bi bi-safe2",
		main_module_code: "BRANCH",
		module_code: "CASH_MANAGE",
		required_verb: "create",
		navigate_to: "/branch/cash_management",
	},
	{
		id: "set_change_fund",
		label: "ตั้งค่าเงินทอนเริ่มต้น POS",
		keywords: ["เงินทอน", "เงินทอนเริ่มต้น", "ทอนเงิน", "change fund", "default change fund"],
		breadcrumb: "สาขา › จัดการเงินสด",
		icon: "bi bi-cash-coin",
		main_module_code: "BRANCH",
		module_code: "CASH_MANAGE",
		required_verb: "edit",
		navigate_to: "/branch/cash_management",
	},
	{
		id: "request_cash_count",
		label: "ขอนับเงินกะ POS",
		keywords: ["ขอนับเงิน", "นับเงิน", "นับกะ", "request count", "cash count"],
		breadcrumb: "สาขา › จัดการเงินสด",
		icon: "bi bi-calculator",
		main_module_code: "BRANCH",
		module_code: "CASH_MANAGE",
		required_verb: "edit",
		navigate_to: "/branch/cash_management",
	},

	// ── Setting ──
	{
		id: "open_pos_device_registration",
		label: "เปิดช่องลงทะเบียนเครื่อง POS",
		keywords: ["ลงทะเบียน pos", "เพิ่มเครื่อง pos", "เปิดช่องลงทะเบียน", "เครื่องขาย", "register pos", "pos device", "device registration"],
		breadcrumb: "ตั้งค่า › จัดการเครื่อง POS",
		icon: "bi bi-display",
		main_module_code: "SETTING",
		module_code: "DEVICE_MANAGE",
		required_verb: "create",
		navigate_to: "/setting/pos_device",
	},
	{
		id: "add_user",
		label: "เพิ่มผู้ใช้งาน",
		keywords: ["เพิ่มผู้ใช้", "สร้างผู้ใช้", "ผู้ใช้งานใหม่", "เพิ่มยูสเซอร์", "add user", "create user", "user management"],
		breadcrumb: "ตั้งค่า › User Management",
		icon: "bi bi-person-plus",
		main_module_code: "SETTING",
		module_code: "USER_MANAGEMENT",
		required_verb: "create",
		navigate_to: "/setting/user_management",
	},
	{
		id: "add_role",
		label: "เพิ่ม Role",
		keywords: ["เพิ่ม role", "สร้าง role", "บทบาท", "สิทธิ์", "add role", "create role", "role management"],
		breadcrumb: "ตั้งค่า › Role Management",
		icon: "bi bi-person-badge",
		main_module_code: "SETTING",
		module_code: "ROLE_MANAGEMENT",
		required_verb: "create",
		navigate_to: "/setting/role_management",
	},
	{
		id: "add_payment_channel",
		label: "เพิ่มช่องทางการชำระเงิน",
		keywords: ["เพิ่มช่องทางชำระ", "ช่องทางชำระเงิน", "วิธีชำระ", "add payment channel", "create payment", "payment method"],
		breadcrumb: "ตั้งค่า › ช่องทางการชำระเงิน",
		icon: "bi bi-credit-card",
		main_module_code: "SETTING",
		module_code: "PAYMENT_CHANNEL",
		required_verb: "create",
		navigate_to: "/setting/payment_channel",
	},
	{
		id: "edit_point_setting",
		label: "แก้ไขการตั้งค่าคะแนน",
		keywords: ["ตั้งค่าคะแนน", "กฎคะแนน", "อัตราแลกคะแนน", "สะสมคะแนน", "แลกคะแนน", "คะแนนหมดอายุ", "point setting", "point expiry"],
		breadcrumb: "ตั้งค่า › ตั้งค่าคะแนน",
		icon: "bi bi-star",
		main_module_code: "SETTING",
		module_code: "POINT_SETTING",
		required_verb: "edit",
		navigate_to: "/setting/point_setting",
	},
	{
		id: "add_receipt_format",
		label: "เพิ่มรูปแบบใบเสร็จ",
		keywords: ["เพิ่มใบเสร็จ", "รูปแบบใบเสร็จ", "ใบเสร็จ", "add receipt format", "create receipt", "receipt format"],
		breadcrumb: "ตั้งค่า › รูปแบบใบเสร็จ",
		icon: "bi bi-receipt",
		main_module_code: "SETTING",
		module_code: "RECEIPT_FORMAT",
		required_verb: "create",
		navigate_to: "/setting/receipt_format",
	},
	{
		id: "add_module",
		label: "เพิ่มโมดูล Backoffice",
		keywords: ["เพิ่มโมดูล", "สร้างโมดูล", "backoffice module", "add module", "create module", "module management"],
		breadcrumb: "ตั้งค่า › Module Management",
		icon: "bi bi-grid-1x2",
		main_module_code: "SETTING",
		module_code: "MODULE_MANAGEMENT",
		required_verb: "create",
		navigate_to: "/setting/module_management",
	},
	{
		id: "add_pos_module",
		label: "เพิ่มโมดูล POS",
		keywords: ["เพิ่มโมดูล pos", "เมนู pos", "pos module", "add pos module", "create pos module"],
		breadcrumb: "ตั้งค่า › POS Module Management",
		icon: "bi bi-layout-text-sidebar",
		main_module_code: "SETTING",
		module_code: "P_MODULE_MANAGEMENT",
		required_verb: "create",
		navigate_to: "/setting/pos_modules",
	},

	// ── Holiday ──
	{
		id: "add_holiday",
		label: "เพิ่มวันหยุด",
		keywords: ["เพิ่มวันหยุด", "สร้างวันหยุด", "วันหยุดสาขา", "add holiday", "create holiday", "holiday"],
		breadcrumb: "วันหยุด › จัดการวันหยุด",
		icon: "bi bi-calendar-plus",
		main_module_code: "HOLIDAY",
		module_code: "HOLIDAY_MANAGE",
		required_verb: "create",
		navigate_to: "/holiday/management",
	},
];
